<template>
    <div class="page-packagefo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">客服專區</div>
            <div class="breadcrumb-item">包裹預報</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <DatePicker type="date" size="small" placeholder="起始日期" :options="options3" v-model="form.start_time" value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker type="date" size="small" placeholder="結束日期" :options="options3" v-model="form.end_time" value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
                </FormItem>
                
				<Form inline class="pg-form-inline form-input-wrap">
                    <FormItem>
                        <label class="input-label">用戶電話</label>
                        <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
                    </FormItem>
                    <FormItem>
                        <label class="input-label">快遞單號</label>
                        <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
                    </FormItem>
                    <FormItem>
                        <label class="input-label">訂單編號</label>
                        <Input size="small" clearable v-model="form.order_number" @keyup.enter.native="handleSearch()"></Input>
                    </FormItem>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" @click="handleSearch">搜索</div>
                            <div class="pg-btn style2" @click="handleExport">导出</div>
                        </div>
                    </FormItem>
				</Form>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   ref="selection"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleShowEidt(row)">修改</div>
                        <div class="pg-btn style1" @click="handleDel(row.id)">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total mg-r10">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        
        <Modal v-model="showedit"
               title="修改"
               width="400"
               :footer-hide="true">
            <div class="modal-cont">
                <Form>
                    <FormItem>
                        <label class="input-label">快遞單號</label>
                        <Input clearable v-model="editForm.phone"></Input>
                    </FormItem>
                    <FormItem>
                        <label class="input-label">快遞單號</label>
                        <Input clearable v-model="editForm.odd_number"></Input>
                    </FormItem>
                    <FormItem>
                        <label class="input-label">訂單編號</label>
                        <Input clearable v-model="editForm.order_numbers"></Input>
                    </FormItem>
                    <FormItem>
                        <label class="input-label">商品描述</label>
                        <Input clearable v-model="editForm.order_remark"></Input>
                    </FormItem>
                    
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%;" @click="handleEidt">確定</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import Store from '../../../assets/js/store.js'

    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                form: {
                    start_time: '',
                    end_time: '',
                    phone: '',
                    odd_numbers: '',
                    order_number: '',
                },
                editForm: {
                    o_id: '',
                    phone: '',
                    odd_number: '',
                    order_numbers: '',
                    order_remark: '',
                    // u_id: JSON.parse(localStorage.getItem('jyb_logInfo')).user_id,
                },
                isSubmiting: false,
                options3: {
                    disabledDate (date) {
                        return date && date.valueOf() > Date.now();
                    }
                },
                showedit: false,
                table: {
                    column: [
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 230
                        },
                        {
                            title: '用戶電話',
                            key: 'phone',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '快遞單號',
                            key: 'odd_number',
                            align: 'center',
                            sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '訂單編號',
                            key: 'order_numbers',
                            align: 'center',
                            sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '產品描述',
                            key: 'order_remark',
                            align: 'center',
                            sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '預報時間',
                            key: 'created_at',
                            align: 'center',
                            minWidth: 160
                        }
                
                    ],
                    data: []
                }
            };
        },
        created()
        {
            this.getList()
        },
        methods: {
            // 刪除
            handleDel(id) {
                let _this = this
                this.$Modal.confirm({
                    title: '警告',
                    content: '<p>是否要删除</p>',
                    onOk: () => {
                        _this.$Rq.requestAuth({
                            url: this.$Api.advanceOrder_del,
                            method: 'post',
                            data: {
                                o_id: id
                            }
                        }).then((res) => {
                            _this.$Message.info(res.msg)
                            _this.getList();
                        }).catch((err) => {
                            _this.$Message.error('服務端異常，請重試')
                        });
                    },
                    onCancel: () => {
                    
                    }
                });
                
            },
            // 修改
            handleShowEidt(item) {
                for (const editFormKey in this.editForm) {
                    this.editForm[editFormKey] = item[editFormKey]
                    this.editForm['o_id'] = item['id']
                }
                this.showedit = true
            },
            // 確認 修改
            handleEidt() {
                let form = this.editForm
                this.$Rq.requestAuth({
                    url: this.$Api.advanceOrder_edit,
                    method: 'post',
                    data: form
                }).then((res) => {
                    this.$Message.info(res.msg)
                    this.showedit = false;
                    this.getList();
                }).catch((err) => {
                    this.$Message.error('服務端異常，請重試')
                });
                
            },
            // 导出
            handleExport() {
                let token = localStorage.getItem('jyb_token');
                let form = this.form;
                let params = {
                    'Authorization': token,
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
                    phone: form.phone,
                    odd_numbers: form.odd_numbers,
                    order_number: form.order_number,
                };
                let formatParams = this.$Utils.formateObjToParamStr(params);
                if(new Set(Object.values(this.form)).size === 1){
                    this.$Utils.showTipInfo("請輸入搜索條件");
                    return false;
                }
                let a = document.createElement('a')
                a.href = `${this.$Api.exportDailyCountStoreNew}?${formatParams}`
                a.click()
            },
            // 获取列表
            getList() {
                let form = this.form;
                form.start_time = this.formatDate(form.start_time)
                form.end_time = this.formatDate(form.end_time)
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.advanceOrder_list,
                    method: 'get',
                    data: {...form,page: this.pageIndex}
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let temdata = res.data.data.map(item => {
                            item.phone = item.userinfo?.phone
                            return item
                        })
                        this.table.data = temdata
                        this.totalCount = res.data.count;
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
    
            formatDate(datetime) {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num) {
                return num < 10 ? '0' + num : num;
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "packageFo.scss";
</style>
